module.exports = __webpack_public_path__ + "img/2.ba9f9453.png";